// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"373":"f520d4bb","517":"68deaf30"}[chunkId] + ".chunk.js";
};